<div class="dt-table-container">
  <table class="dt-table">
    <thead>
      <tr>
        @if (showCheckboxes) {
        <th class="checkbox-col">
          <input type="checkbox" [checked]="selectAll" (change)="onSelectAll()" class="checkbox"
            aria-label="Select all rows" />
        </th>
        }

        @for (column of columns; track column.key) {
        @if ( column.key === "actions" ){
        <th class="actions-col"></th>
        }
        <th class="table-header" [class.table-header--actions]="column.key === 'actions'">
          @if (column.key !== 'actions') {
          {{ column.label }}
          }
        </th>
        }
      </tr>
    </thead>

    <tbody>
      @for (row of paginatedRows; track row.id) {
      <tr [class.selected]="isRowSelected(row.id) || row['isSelected']" [class.dt-row--active-dropdown]="activeDropdownRowId === row.id" (click)="rowClick.emit(row)" style="cursor:pointer">
        @if (showCheckboxes) {
        <td class="checkbox-col">
          <input type="checkbox" [checked]="isRowSelected(row.id)" (change)="onSelectRow(row.id)" class="checkbox"
            [attr.aria-label]="'Select row ' + row.id" />
        </td>
        }

        @for (column of columns; track column.key) {
        <td class="table-cell" [class.actions-cell]="getColumnType(column) === 'actions'">
          @switch (getColumnType(column)) {
          @case ('name') {
          <div class="name-cell">
            @if (avatarType !== 'none') {
            <div class="avatar">
              @if (avatarType === 'icon' && (row['avatarIconPath'] || iconUrl)) {
              <img class="avatar__icon" [src]="row['avatarIconPath'] || iconUrl" [alt]="row[column.key] || 'icon'" />
              } @else {
              {{ row[column.key] | initials }}
              }
            </div>
            }

            <div class="name-content">
              <span class="name-text">{{ row[column.key] }}</span>

              @if (row['userCode'] && showSubText) {
              <span class="sub-text">{{ row['userCode'] }}</span>
              }

              @if (!row['userCode'] && row['code'] && showSubText) {
              <span class="sub-text">{{ row['code'] }}</span>
              }
            </div>
          </div>
          }

          @case ('email') {
          <span class="subtle-text">{{ row[column.key] }}</span>
          }

          @case ('phone') {
          <span class="subtle-text">{{ row[column.key] }}</span>
          }

          @case ('badge') {
          <span [class]="getBadgeClass(column, row[column.key], row)">
            <span class="badge-dot"></span>
            {{ row[column.key] }}
          </span>
          }

          @case ('status') {
          <span [class]="getStatusClass(row[column.key])">
            <span class="status-dot"></span>
            {{ row[column.key] }}
          </span>
          }

          @case ('number') {
          <span class="numeric" [class.numeric--danger]="row['highlightNegative'] && row[column.key] > 0">
            {{ formatNumber(row[column.key]) }}
          </span>
          }

          @case ('date') {
          @if (column.subKey && row[column.subKey]) {
          <div class="name-content">
            <span class="subtle-text">{{ row[column.key] }}</span>
            <span class="sub-text">{{ row[column.subKey] }}</span>
          </div>
          } @else {
          <span class="subtle-text">{{ row[column.key] }}</span>
          }
          }

          @case ('hierarchy') {
          <div class="parent-cell">
            @for (item of row[column.key]; track $index) {
            <span class="parent-chip">{{ item }}</span>
            }
          </div>
          }

          @case ('actions') {
          <div class="actions-wrapper">
            <button type="button" class="actions-button" aria-label="Open row actions" (click)="toggleDropdown(row.id, $event)">
              •••
            </button>
            @if (activeDropdownRowId === row.id && getVisibleActions(row).length > 0) {
              <div class="actions-dropdown">
                @for (action of getVisibleActions(row); track action.label) {
                  <button type="button" class="actions-dropdown__item" (click)="onActionClick(action, row, $event)">
                    @if (action.icon) {
                      @if (isIconUrl(action.icon)) {
                        <img class="actions-dropdown__icon-img" [src]="action.icon" [alt]="action.label" />
                      } @else {
                        <span class="actions-dropdown__icon-text">{{ action.icon }}</span>
                      }
                    }
                    <span class="actions-dropdown__label">{{ action.label }}</span>
                  </button>
                }
              </div>
            }
          </div>
          }

          @case ('roleCell') {
          <div class="role-cell">
            @if (iconUrl) {
            <div class="avatar avatar--icon">
              <img class="avatar__icon" [src]="iconUrl" [alt]="row[column.key].name || 'role icon'" />
            </div>
            }
            <div class="role-cell__content">
              <div class="role-cell__top">
                <span class="role-cell__name">{{ row[column.key].name }}</span>
                @if (row[column.key].badge) {
                <span class="role-cell__badge">{{ row[column.key].badge }}</span>
                }
              </div>
              <div class="role-cell__description">{{ row[column.key].description }}</div>
            </div>
          </div>
          }

          @case ('linkedUsers') {
          <div class="linked-users-cell">
            <span>{{ row[column.key].count }}</span>
          </div>
          }

          @case ('tags') {
          <span class="tags-count">{{ row[column.key] }}</span>
          }

          @default {
          @if (column.subKey && row[column.subKey]) {
          <div class="name-content">
            <span>{{ row[column.key] }}</span>
            <span class="sub-text">{{ row[column.subKey] }}</span>
          </div>
          } @else {
          <span>{{ row[column.key] }}</span>
          }
          }
          }
        </td>
        }
        }

        @if (rows.length === 0) {
      <tr>
        <td [attr.colspan]="columns.length + (showCheckboxes ? 1 : 0)" class="empty-cell">
          No data found
        </td>
      </tr>
      }
    </tbody>
  </table>

  @if (showPagination && totalResults > 0) {
  <div class="table-footer">
    <div class="table-footer__summary">
      Showing <strong>{{ startItem }}–{{ endItem }}</strong> of {{ totalResults }} {{resultsLabel}}
    </div>

    <div class="dt-pagination">
      <button type="button" class="dt-pagination__button dt-pagination__button--icon" (click)="onPageChange(currentPage - 1)"
        [disabled]="currentPage === 1" aria-label="Previous page">
        ‹
      </button>

      @for (page of getVisiblePages(); track page) {
      <button type="button" class="dt-pagination__button" [class.dt-pagination__button--active]="page === currentPage"
        (click)="onPageChange(page)">
        {{ page }}
      </button>
      }

      <button type="button" class="dt-pagination__button dt-pagination__button--icon" (click)="onPageChange(currentPage + 1)"
        [disabled]="currentPage === totalPages" aria-label="Next page">
        ›
      </button>
    </div>
  </div>
  }
</div>